import React, { Component } from 'react'
import { observer } from 'mobx-react'
import CompanyTasksTable from './companytaskstable.js'

@observer(['globals', 'tasks'])
export default class Completed extends Component {

  constructor(props) {
    super(props)
  }

  reload(callback) {
    this.props.tasks.loadAllCompletedTasks(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  render() {
    return (
      <div>
        <CompanyTasksTable data={ this.props.tasks.completed } reload={ this.reload.bind(this) } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tasks/completed.js